import { BrandEnum } from "@infrastructure/brand.enum";

export class SetManualDefaultModel {
	constructor(
		public ModelSizeId: number | undefined,
		public ModelConfigId: number | undefined,
		public ModelId: number | undefined,
		public Brand: BrandEnum,
		public ManualDefaultVariants?: Array<SetManualDefaultVariantModel>
	) { }
}

export class SetManualDefaultVariantModel {
	constructor(
		public ComponentVariantId: number,
		public ComponentSizeId?: number | null,
		public ComponentColorId?: number | null,
		public ColorId?: number | null
	) { }
}
